import { useSelector } from 'react-redux';
import { createAction, createReducer } from 'redux-act';

import type { MobileGatewayV2 } from '@src/@types/promo';

import type { IGlobalState } from '.';

type IState = Partial<MobileGatewayV2.IPromoBannerResponse>;

const initialState: IState = {};

export const setPromo = createAction<IState>('promo/set');

export const promoReducer = createReducer<IState>({}, initialState).on(setPromo, (_state, payload) => payload);

const getPromo = (state: IGlobalState) => state.promo.isPromoCandidate;

export const useIsPromoActive = () => useSelector(getPromo);
